<template>
    <input type="text" :value='message' @change='inputting' @input='inputting'>
</template>

<script>
    import Flatpickr from './flatpickr';

    export default {
        name: 'v-datepicker',
        data () {
            return {
                fp: null
            }
        },
        props: {
            options: {
                type: Object,
                default: () => {
                    return {

                    }
                }
            },
            message: {
                type: String,
                default: () => ''
            },
            color: {
                type: String,
                required: false
            },
            bgColor: {
                type: String,
                required: false
            },
            disableColor: {
                type: String,
                required: false
            }
        },
        watch: {
            options: {
                handler: function(opt) {
                    for (let o in opt) {
                        this.fp.set(o, opt[o])
                    }
                },
                deep: true
            },
            message (val) {
                try {
                    val = val.split(this.fp.l10n.rangeSeparator);
                    this.fp.setDate(val, false);
                } catch(e) {}
            },
        },
        methods: {
            inputting (e) {
                this.$emit('input', e.target.value)
            }
        },
        mounted () {
            Flatpickr.l10ns.zh = {
                rangeSeparator: ' ~ ',
                weekdays: {
                    shorthand: ['日', '一', '二', '三', '四', '五', '六'],
                    longhand: ['日', '一', '二', '三', '四', '五', '六']
                },
                months: {
                    shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                }
            };

            this.options.locale = 'zh';
            this.options.prevArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 20 20"><g></g><path d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"></path></svg>';
            this.options.nextArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 20 20"><g></g><path d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"></path></svg>'

            this.fp = new Flatpickr(this.$el, this.options);
            if(this.bgColor){
                this.fp.changeMonthNavBackColor(this.bgColor);
            }
            if(this.color&&this.bgColor&&this.disableColor){
                this.fp.changeDayStyle(this.color,this.bgColor,this.disableColor);
            } 
            this.$emit('flatpickr-ref', this.fp)
        },
        destroyed () {
            this.fp.destroy()
        }
    }
</script>



// WEBPACK FOOTER //
// datepicker.vue?63899a45